  (function() {
    var script = document.createElement('script');
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.async = true;
    script.onload = function() {
      window.posthog.init('phc_zQk6jGnntbEoxgax66KdWRDr7hpccJjZfnjtHwNiiC7c', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'always',
        capture_pageleave: true
      });
    };
    document.head.appendChild(script);
  })();